import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { SecurityLockService } from './security-lock.service';

export const authGuard: CanActivateFn = async (_route, state): Promise<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const securityLock = inject(SecurityLockService);

  if (securityLock.isLocked()) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }

  await auth.initialize();
  if (auth.isAuthenticated()) return true;

  if (await auth.restoreOfflineSession()) return true;

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};